import React from 'react'
import List from '@mui/material/List'
import { grey } from '@mui/material/colors'
import { useTranslation } from 'react-i18next'

import ListItemButton from 'components/Sidebar/Styled/Button'
import SubMenu from 'components/Sidebar/Menu/SubMenu'
import { customStyles } from 'components/Sidebar/Styled/CustomStyles'
import { SiteManageProps } from 'types/Sidebar'
import { renderIfAllowed } from 'lib/authorization/AuthorizeComponent'
import bluehavenDomain from 'lib/utility/BluehavenDomain'
import ListItemText from 'components/Sidebar/Styled/ListItemText'

const SiteManage = ({
  handleDropdownCollapse,
  isDrawerVisible,
}: SiteManageProps) => {
  const { t } = useTranslation()

  return (
    <>
      <SubMenu
        dataTestId="site-management"
        keyItem="site-management"
        name="siteManagement"
        isDrawerVisible={isDrawerVisible}
        handleDropdownCollapse={handleDropdownCollapse}
      >
        <List
          component="div"
          sx={{ backgroundColor: grey[100] }}
          disablePadding
        >
          {renderIfAllowed(
            'homepage manager',
            <ListItemButton
              data-testid="homepage-manager"
              component="a"
              href={`${bluehavenDomain()}/admin/sites/theme/editor`}
              key="homepage-manager"
              sx={customStyles.listItemButton}
            >
              <ListItemText primary={t('sidebar.homepageManager')} />
            </ListItemButton>,
          )}
          {renderIfAllowed(
            'hubpage manager',
            <ListItemButton
              component="a"
              data-testid="hubpage-manager"
              href={`${bluehavenDomain()}/admin/site_hubs`}
              key="hubpage-manager"
              sx={customStyles.listItemButton}
            >
              <ListItemText primary={t('sidebar.hubpageManager')} />
            </ListItemButton>,
          )}
          {renderIfAllowed(
            'static-pages',
            <ListItemButton
              component="a"
              data-testid="static-manager"
              href={`${bluehavenDomain()}/admin/static_pages`}
              key="static-pages"
              sx={customStyles.listItemButton}
            >
              <ListItemText primary={t('sidebar.staticPages')} />
            </ListItemButton>,
          )}
          {renderIfAllowed(
            'theme',
            <ListItemButton
              component="a"
              data-testid="theme"
              href={`${bluehavenDomain()}/admin/sites/theme`}
              key="theme"
              sx={customStyles.listItemButton}
            >
              <ListItemText primary={t('sidebar.theme')} />
            </ListItemButton>,
          )}
          {renderIfAllowed(
            'navigation',
            <ListItemButton
              component="a"
              href={`${bluehavenDomain()}/admin/site/navigations`}
              key="navigation"
              data-testid="navigation"
              sx={customStyles.listItemButton}
            >
              <ListItemText primary={t('sidebar.navigations')} />
            </ListItemButton>,
          )}

          <ListItemButton
            component="a"
            data-testid="audit-logs"
            href={`${bluehavenDomain()}/admin/audit_logs`}
            key="audit-logs"
            sx={customStyles.listItemButton}
          >
            <ListItemText primary={t('sidebar.auditTrail')} />
          </ListItemButton>
        </List>
      </SubMenu>
    </>
  )
}

export default SiteManage
